import { useState } from 'react';
import { theme } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import UserRecoveryService from 'services/user_recovery';
import { useApp } from 'contexts/app';

const service = new UserRecoveryService();

const useResetPass = () => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const [otpForm] = useForm();
  const { showLoading, message } = useApp();

  const navigate = useNavigate();
  const [idOtp, setIdOtp] = useState();
  const [isShowOtp, setIshowOpt] = useState(false);

  const handleCreate = () => {
    form.submit();
  };

  const onFinish = async () => {
    const data = { ...form.getFieldsValue() };
    showLoading(true);
    const { otp } = await service.requestResetPass(data);
    setIdOtp(otp.id);
    showLoading(false);
    setIshowOpt(true);
  };

  const onOtpFinish = async () => {
    const data = { ...otpForm.getFieldsValue() };
    showLoading(true);
    try {
      const createdUser = await service.changePassWithOTP({ id: idOtp, otp: data.otp });
      if (createdUser) {
        navigate('/passreseted');
      }
    } catch (error) {
      message.error(error.message);
    }

    showLoading(false);
  };

  return {
    token,
    form,
    otpForm,
    navigate,
    isShowOtp,
    setIshowOpt,
    handleCreate,
    onFinish,
    onOtpFinish,
  };
};

export default useResetPass;
